import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  Container,
  Card,
  Form,
  Row,
  Col,
  ButtonGroup,
  Button,
} from "react-bootstrap";
import { ThreeDots } from 'react-loader-spinner';
import { updateLeaveEntitlement, resetList, updateEntitlebyID, addEntitle } from "../../3.Store/LeaveEntitlementSlice";
import { getServiceLengths } from "../../3.Store/ServiceLengthsSlice";
import { getCatagories } from "../../3.Store/EmployeeCatagoriesSlice";

const LeaveEntitlementAdd = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const entitle = useSelector(state => state.LeaveEntitlementSlice.entitle);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const { annual, sick, medical, hospitalization, service_length, employee_catagory, remark  } = entitle;
  const catagories = useSelector((state) => state.EmployeeCatagoriesSlice.employeeCatagories);
  const lengths = useSelector((state) => state.ServiceLengthsSlice.serviceLengths);
  const loadingCatagories = useSelector((state) => state.EmployeeCatagoriesSlice.loading);
  const loadingLengths = useSelector((state) => state.ServiceLengthsSlice.loading);
  const loading = loadingCatagories || loadingLengths;

  useEffect(() => {
    dispatch(getCatagories());
    dispatch(getServiceLengths());
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const selectedCategory = catagories.find(cat => cat.id === employee_catagory.id);
    const selectedLength = lengths.find(len => len.id === service_length.id);
    const newRemark = `${selectedCategory?.description || ''} (${selectedLength?.description || ''})`;
    if (selectedCategory || selectedLength) {
      dispatch(updateLeaveEntitlement({ ...entitle, remark: newRemark }));
    }
  }, [employee_catagory.id, service_length.id, catagories, lengths]);

  const handleUpdate = (e) => {
    const entity = { ...entitle, [e.target.name]: e.target.value };
    console.log(entity);
    dispatch(updateLeaveEntitlement(entity));
  };

  const handleUpdateDropdown = (e) => {
    const entity = { ...entitle, [e.target.name]: {id: e.target.value} };
    console.log(entity);
    dispatch(updateLeaveEntitlement(entity));
  };

  const handleBtnAdd = () => {
    if (!employee_catagory.id) {
      Swal.fire("", "Please select Employee Category", "warning");
      return;
    }
    if (!service_length.id) {
      Swal.fire("", "Please select Service Length", "warning");
      return;
    }
    if (Number(annual) <= 0 && Number(sick) <= 0 && Number(medical) <= 0 && Number(hospitalization) <= 0) {
      Swal.fire("", "Please fill leave entitlement with a value greater than 0", "warning");
      return;
    }

    const int = v => Number(v) | 0;

    const entity = {
      ...entitle,
      id: `${employee_catagory.id}${service_length.id}`,
      description: `Annual:${int(annual)}, Sick:${int(sick)}, Hospitalization:${int(hospitalization)}, Medical ${int(medical)}`,
      advanced: 5.0,
      special: 3.0,
      maternity: 60.0,
    };
    console.log(entity);

    dispatch(addEntitle(entity))
      .unwrap()
      .then(() => {
        Swal.fire("Record Added", "", "success").then(() => {
          navigate(`/Entitlement`);
        });
      })
      .catch((err) => {
        Swal.fire("", err?.response?.data || err?.message, "error");
      });
  };      
  
  const handleBtnBack = () => {
    dispatch(resetList());
    navigate(`/Entitlement`);
  };

  return (
    <Container className="ContainerContent">
      {loading && (
        <ThreeDots
          visible={loading}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent2">

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>

        <h1 className="TitleHeader">Leave Entitlement</h1>
        <h1 className="MiniTitleHeader">Add</h1>

        <Row className="my-3">
          <Col md={12} sm={12}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Employee Category</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Select name="employee_catagory" value={employee_catagory.id || ""} onChange={handleUpdateDropdown}>
                  <option value="">Select Category</option>
                  {catagories.map((cat) => (
                    <option key={cat.id} value={cat.id}>{cat.description}</option>
                  ))}
                </Form.Select>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={12} sm={12}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Service Length</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Select name="service_length" value={service_length.id || ""} onChange={handleUpdateDropdown}>
                  <option value="">Select Service Length</option>
                  {lengths.map((len) => (
                    <option key={len.id} value={len.id}>{len.description}</option>
                  ))}
                </Form.Select>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={12} sm={12}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Remark</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="remark" value={remark} onChange={handleUpdate}/>
              </Col>
            </Row>
          </Col>
        </Row>

        <hr className="hr-white" />

        <Row className="my-3">
          <Col md={12} sm={12}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Annual Leave</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="annual" value={annual} onChange={handleUpdate}/>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={12} sm={12}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Sick Leave</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="sick" value={sick} onChange={handleUpdate}/>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={12} sm={12}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Medical Claim</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="medical" value={medical} onChange={handleUpdate}/>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={12} sm={12}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Hospitalization</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="hospitalization" value={hospitalization} onChange={handleUpdate}/>
              </Col>
            </Row>
          </Col>
        </Row>

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
          &nbsp; &nbsp;
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnAdd}>
              Add
            </Button>
          </ButtonGroup>
        </div>
      </Card>
    </Container>
  );
};

export default LeaveEntitlementAdd;